import {
    GESTION_OPERATIVA_RE_ENTERED_VEHICLE_SUCCESS,
    GESTION_OPERATIVA_RE_ENTERED_VEHICLE_FAILURE,
    GESTION_OPERATIVA_RE_ENTERED_VEHICLE_BEGIN
} from '../constants'

export function reducer(state, action) {
    switch (action.type) {
        case GESTION_OPERATIVA_RE_ENTERED_VEHICLE_BEGIN:
            return {
                ...state,
                sale: {
                    ...state.sale,
                    bill: {
                        ...state.sale.bill,
                        reEnteredVehiclePending: true,
                        reEnteredVehicleError: null,
                        reEnteredVehicleData: null
                    }
                }
            }
        case GESTION_OPERATIVA_RE_ENTERED_VEHICLE_SUCCESS:
            return {
                ...state,
                sale: {
                    ...state.sale,
                    bill: {
                        ...state.sale.bill,
                        reEnteredVehiclePending: false,
                        reEnteredVehicleError: null,
                        reEnteredVehicleData: action.data
                    }
                }
            }
        case GESTION_OPERATIVA_RE_ENTERED_VEHICLE_FAILURE:
            return {
                ...state,
                sale: {
                    ...state.sale,
                    bill: {
                        ...state.sale.bill,
                        reEnteredVehiclePending: false,
                        reEnteredVehicleError: true,
                        reEnteredVehicleData: null
                    }
                }
            }
        default:
            return state
    }
}